<template>
  <footer
    class="[ mk-fe-frontendFooter art-fe-footer ]"
    style="filter: opacity(1);"
  >
    <div class="container-fluid">
      <div class="container">
        <div class="row">

          <div class="[ footer-info-wrap ] col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mx-auto px-0 ">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <img
                  src="/images/branding/artsight-logo-text-white.png" class="img-fluid"
                  style="max-height: 30px;"
                />
              </div>

              <div>
                <a target="_blank" href="https://www.facebook.com/artsightart">
                  <i class="fa-brands fa-facebook text-white fa-2xl"></i>
                </a>
                <a class="ml-4" target="_blank" href="https://www.instagram.com/artsight.art/">
                  <i class="fa-brands fa-instagram text-white fa-2xl"></i>
                </a>
              </div>
            </div>

            <div>
              <a class="fs-16 fw-700 text-white" target="_blank" href="https://www.artsight.com.au/">About Us</a>
            </div>

            <div>
              <a class="fs-16 fw-700 text-white" target="_blank" href="https://www.artsight.com.au/get-in-touch">Get in touch</a>
            </div>

            <div class="d-flex align-items-center">
              <a class="color-200-placeholder mr-3" href="/">Privacy Policy</a>
              <a class="color-200-placeholder" href="/">Terms & Conditions</a>
            </div>

          </div>

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>